import apiService from "./api.service";

export const sendotp = async (payload, callback, error) => {
  await apiService.post(
    "appointment/sendotp",
    payload,
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};

export const verifyotp = async (payload, callback, error) => {
  await apiService.post(
    "appointment/verifyotp",
    payload,
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};

export const doctorlist = async (callback, error) => {
  await apiService.get(
    "appointment/doctor/list",
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};

export const carenavigatorlist = async (callback, error) => {
  await apiService.get(
    "appointment/carenavigator/list",
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};

export const fetchslots = async (payload, callback, error) => {
  await apiService.post(
    "appointment/fetchslots",
    payload,
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};

export const bookAppointmentAPI = async (payload, callback, error) => {
  await apiService.post(
    "appointment/book",
    payload,
    (status, res) => {
      return callback(status, res);
    },
    (err) => {
      return error(err);
    }
  );
};